import { Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { SITE } from "../data/mock";

const CTABand = ({
  eyebrow = "Reach out today",
  title = "You don’t have to figure this out alone.",
  body = "A Certified Recovery Peer Specialist is ready to listen — confidentially and without judgment.",
  primary = { label: "Call 407.RECOVER", href: `tel:${SITE.helplineTel}`, external: true },
  secondary = { label: "Send us a message", href: "/contact" },
}) => {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-[hsl(var(--rc-deep))] text-white p-8 md:p-14">
          <div
            aria-hidden
            className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-[hsl(var(--rc-purple))]/40 blur-3xl"
          />
          <div
            aria-hidden
            className="absolute -bottom-24 -left-20 w-80 h-80 rounded-full bg-[hsl(var(--rc-gold))]/15 blur-3xl"
          />
          <div className="relative grid md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-8">
              <p className="text-[12px] tracking-[0.22em] uppercase text-[hsl(var(--rc-gold))] font-semibold">
                {eyebrow}
              </p>
              <h3 className="font-serif-display mt-3 text-[30px] md:text-[40px] leading-[1.1] font-semibold">
                {title}
              </h3>
              <p className="mt-4 text-[15.5px] md:text-[16.5px] leading-[1.7] text-white/80 max-w-2xl">
                {body}
              </p>
            </div>
            <div className="md:col-span-4 flex flex-col gap-3">
              {primary?.external ? (
                <Button
                  asChild
                  size="lg"
                  className="bg-white hover:bg-[hsl(var(--rc-gold-soft))] text-[hsl(var(--rc-deep))] rounded-full h-12 px-6 font-semibold"
                >
                  <a href={primary.href}>
                    <Phone className="w-4 h-4 mr-2" />
                    {primary.label}
                  </a>
                </Button>
              ) : (
                <Button
                  asChild
                  size="lg"
                  className="bg-white hover:bg-[hsl(var(--rc-gold-soft))] text-[hsl(var(--rc-deep))] rounded-full h-12 px-6 font-semibold"
                >
                  <Link to={primary.href}>{primary.label}</Link>
                </Button>
              )}
              {secondary && (
                <Button
                  asChild
                  variant="outline"
                  size="lg"
                  className="rounded-full h-12 px-6 border-white/30 bg-transparent hover:bg-white/10 text-white hover:text-white"
                >
                  <Link to={secondary.href} className="flex items-center">
                    {secondary.label}
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Link>
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABand;
